import PAID_LEAVE from './paidLeave'
import PAID_SICK_LEAVE from './paidSickLeave'
import PAID_FAMILY_MEDICAL_LEAVE from './paidFamilyMedicalLeave'
import TABLE_HEADERS from './tableHeaders'

const getProduct = (product) => ({
  id: product.JSON_VALUE,
  name: product.PRETTY_PRINT,
  productType: product.URI
})

export const DEFAULT_FEDERAL_JURISDICTION = 'United States - Federal'

export const SORT_OPTIONS = Object.freeze({
  name: 'jurisdictionName',
  type: 'jurisdictionType',
  locations: 'locationsAffected'
})

export default Object.freeze({
  NAME: 'paidLeave',
  JURISDICTIONS: {
    city: 0,
    county: 1,
    state: 2,
    federal: 3
  },
  TABLE_HEADERS,
  TYPES: { PAID_LEAVE, PAID_SICK_LEAVE, PAID_FAMILY_MEDICAL_LEAVE },
  get PRODUCTS() {
    return [
      getProduct(PAID_SICK_LEAVE),
      getProduct(PAID_FAMILY_MEDICAL_LEAVE),
      getProduct(PAID_LEAVE)
    ]
  },
  get NOTIFICATIONS() {
    return {
      CSV_HEADER_ROW_VALUES: [
        TABLE_HEADERS.LOCATION_NAME.HEADER,
        TABLE_HEADERS.ADDRESS_1.HEADER,
        TABLE_HEADERS.ADDRESS_2.HEADER,
        TABLE_HEADERS.CITY.HEADER,
        TABLE_HEADERS.STATE.HEADER,
        TABLE_HEADERS.ZIP.HEADER,
        TABLE_HEADERS.COUNTRY.HEADER,
        TABLE_HEADERS.PAID_LEAVE_TYPE.HEADER,
        TABLE_HEADERS.JURISDICTION_NAME.HEADER,
        TABLE_HEADERS.JURISDICTION_TYPE.HEADER,
        PAID_LEAVE.TOPICS.EFFECTIVE_DATE.HEADER,
        'Update content for the applicable jurisdiction'
      ]
    }
  }
})
